import React, { useCallback } from 'react';

import { AutoSizer, List } from 'react-virtualized';

import PickerRow from './PickerRow';

// react-virtualized hard-clips overflow, so this must clear the tallest row:
// tw-py-2 (16px) wrapping the budget-version <select> (tw-py-1 + text-xs +
// 2px borders ≈ 28px), which sits taller than the name line and archived badge.
const ROW_HEIGHT = 56;

/**
 * Virtualised project list for the picker (IB-641), mirroring the
 * react-virtualized AutoSizer + List pattern used by the project-plan
 * RoadmapList. Renders one PickerRow per filtered event.
 */
export default function PickerProjectList({ events, draft, onToggle, onChangeBudget }) {
    const rowRenderer = useCallback(
        ({ index, key, style }) => {
            const event = events[index];

            return (
                <div style={style} key={key}>
                    <PickerRow event={event} entry={draft[event.id]} onToggle={onToggle} onChangeBudget={onChangeBudget} />
                </div>
            );
        },
        [events, draft, onToggle, onChangeBudget],
    );

    if (!events.length) {
        return <div className="tw-flex tw-items-center tw-justify-center tw-h-full tw-text-sm tw-text-charcoal-50">{$t('No projects match your filters')}</div>;
    }

    return (
        <AutoSizer>
            {({ width, height }) => (
                <List
                    width={width}
                    height={height}
                    rowCount={events.length}
                    rowHeight={ROW_HEIGHT}
                    rowRenderer={rowRenderer}
                    /**
                     * Pass-thru props force a re-render when the draft changes
                     * (https://github.com/bvaughn/react-virtualized#pass-thru-props).
                     */
                    draft={draft}
                    events={events}
                />
            )}
        </AutoSizer>
    );
}
